import React, { Component } from "react";
import {
  View,
  StyleSheet,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
  Dimensions,
  Linking,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import Theme from "../argon-ui/Theme";
import { IconButton } from "../components_v2/Buttons";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faPlus,
  faCalendar,
  FONT_FAMILIES,
  faEdit,
} from "../../assets/consts/faCharCodes";
import PersianCalendarPicker from "react-native-persian-calendar-picker";

import * as Actions from "../actions/ApiActions";
import { translate } from "../locales/translate";
import Loading from "../components/Loading";
import OrderListItem from "./components/OrderListItem";
import TimePicker from "../components_v2/TimePicker";
import { getIconPicture } from "./components/Icons";
import FilterItem from "../components_v2/FilterItem";
import { englishToPersianNumber, getDir } from "../util";
import InputBase from "../nativeBase-ui/InputBase";
import CheckboxBase from "../nativeBase-ui/CheckboxBase";
import Select from "../nativeBase-ui/Select";
import InputSearch from "../components_v2/InputSearch";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import { HStack, Toast } from "native-base";
import ToastAlert from "../nativeBase-ui/ToastAlert";
import ModalBase from "../nativeBase-ui/ModalBase";
import { ArButton } from "../argon-ui";

var AppStyle = require("../styles/Style");
const SCREEN_WIDTH = Dimensions.get("window").width;
const SCREEN_HEIGHT = Dimensions.get("window").height;
const MODAL_MAX_HEIGHT = SCREEN_HEIGHT * 0.85;

let moment = require("moment-jalaali");
class CarWashOrdersScreen extends Component {
  constructor(props) {
    super(props);
    this.orderStatuses = ["ALL"];

    this.state = {
      accessToken: "",
      serverUrl: "",
      isLoading: true,
      orderStatusFilter: "ALL",
      orderDescriptionFilter: "",
      loadingError: false,
      loadingErrorMessage: null,
      showModal: 0,
      isNewOrder: true,
      newOrderUnitId: null,
      selectedPaymentItem: null,
      describe: null,
      orderSelected: null,
      pDateDesired: null,
      pTimeDesiredBegin: null,
      pTimeDesiredEnd: null,
      twoModals: false,
      carWashListServiceTime: [],
      carWashListServiceType: [],
      orderPrice: 0,
      userBalance: -1,
      requestItems: [],
      startTime: "00:00:00",
      endTime: "00:00:00",
      isShowingCancelAlert: false,
      paymentOnlineUrl: null,
      isOrderRegistering: true,
      isUserValid: "",
      reservationUser: null,
      getCarwashHasError: "No",
      isCarwashActive: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.CarWash"),
  });
  componentDidMount() {
    let { currentServer, serverUrl } = this.props.appReducer;
    const accessToken = currentServer.accessToken;
    var _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl = _serverUrl + "/";
    }
    this.setState({ accessToken, serverUrl: _serverUrl }, () => {
      this.getBalanceAmount().then(() => {
        this.getCarWashInfo();
        this.props.MyCarWashOrders(accessToken);
        this.getUser();
        this.getUserAreas();
        this.setState({ isLoading: false });
      });
      this.getCarWashServiceInformation();
    });
  }
  getCarWashInfo() {
    let { accessToken, serverUrl } = this.state;
    var url = `${serverUrl}Services/GetCarWashInfo`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ getInfoHasError: "Yes" });
        } else {
          this.setState({ isCarwashActive: resj.boolActive });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get carwash info");
        }
      });
  }
  // === show toast => toast native-base ===
  showToast = (message, status = "error") => {
    const toastDetail = {
      title: message,
      variant: "subtle",
      status,
    };
    Toast.show({
      duration: 2000,
      style: { zIndex: 99999 },
      render: () => {
        return <ToastAlert {...toastDetail} />;
      },
    });
  };

  pressOnAddButton = () => {
    this.setState(
      {
        isNewOrder: true,
        selectedPaymentItem: null,
        describe: null,
        isOrderRegistering: true,
        showModal: 1,
      },
      () => this.getCarWashServiceInformation()
    );
  };
  getCarWashServiceInformation() {
    if (
      this.state.carWashListServiceTime.length === 0 ||
      this.state.carWashListServiceType.length === 0
    ) {
      this.getCarWashServiceTime();
      this.getCarWashServiceType();
    }
    this.getBalanceAmount();
  }
  hideModal = () => {
    this.setState({
      showModal: 0,
      isNewOrder: true,
      selectedPaymentItem: null,
      describe: null,
      orderSelected: null,
      pDateDesired: null,
      pTimeDesiredBegin: null,
      pTimeDesiredEnd: null,
      orderPrice: 0,
      userBalance: -1,
      startTime: "0:00:00",
      endTime: "00:00:00",
      requestItems: [],
      isOrderRegistering: true,
      paymentOnlineUrl: null,
    });
  };
  hideTwoModals = () => {
    this.setState({ twoModals: false });
  };
  hideCancelConfirm() {
    this.setState({
      isShowingCancelAlert: false,
    });
  }
  formatNumber(n) {
    "use strict";
    if (Number.isInteger(n)) {
      return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      return null;
    }
  }
  getUser() {
    let { serverUrl, accessToken } = this.state;

    var url = `${serverUrl}Services/GetRibbonUser/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ isUserValid: "No" }, () => {});
        } else {
          this.setState({ reservationUser: resj, isUserValid: "Yes" });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get user have error ");
        }
      });
  }
  refreshOrderList() {
    this.props.MyCarWashOrders(this.state.accessToken);
    this.hideModal();
  }
  getUserAreas() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetRibbonUserInUnit/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess" || resj.ErrorCode != null) {
          this.setState({ isUserValid: "No" });
        } else {
          var areas = [];
          for (var i in resj) {
            areas.push({
              label: resj[i].strUnitName,
              boolUseUnitCredit: resj[i].boolUseUnitCredit,
              boolIncreaseUnitCredit: resj[i].boolIncreaseUnitCredit,
              value: resj[i].numUnitRef,
            });
          }
          if (Platform.OS == "web") {
            areas.unshift({
              label: translate("api.orderUnit"),
              value: "orderUnit",
            });
          }
          this.setState({
            areaList: areas,
          });
        }
      })
      .catch((err) => {
        {
          console.log(err, "get userInUnit have error ");
          reject(err);
        }
      });
  }
  getCarWashServiceTime() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetCarWashServiceTime/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errorCode) {
          this.setState({ carWashServiceTime: [] });
        } else {
          this.setState({ carWashListServiceTime: resj });
        }
      })
      .catch((err) => {
        {
          console.log(err);
          this.setState({ isLoadingPaymentDetails: false });
          // this.showModalToast(translate("api.getCarWashServiceTimeError"));
        }
      });
  }
  getPaymentOnlineUrl() {
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected?.numRequestID}`);
    args.push(
      `paymentType=${this.state.orderSelected?.payment.numPaymentType}`
    );
    args.push(`Amount=${this.state.orderSelected?.numRequestPrice}`);
    args.push(`orderType=${this.state.orderSelected?.numPublicServiceType}`);

    var url = `${serverUrl}Services/GetOnlinePaymentUrl/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errorCode != null) {
          this.showToast(translate("api.orderAnswerError"));
        } else {
          this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
            if (Platform.OS === "web") {
              window.open(this.state.paymentOnlineUrl);
            } else {
              Linking.openURL(this.state.paymentOnlineUrl);
            }
          });
        }
      })
      .catch((err) => {
        {
          console.log(err);
        }
      });
  }
  getCarWashServiceType() {
    let { serverUrl, accessToken } = this.state;
    var url = `${serverUrl}Services/GetCarWashServiceType/`;
    fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.serviceNoAccess"));
        } else if (resj.errorCode) {
          this.setState({ carWashListServiceType: [] });
        } else {
          let carWashListServiceType = [];
          for (var i in resj) {
            if (resj[i].numActive) {
              carWashListServiceType.push(resj[i]);
            }
          }
          this.setState({ carWashListServiceType: carWashListServiceType });
        }
      })
      .catch((err) => {
        {
          console.log(err);
          this.setState({ isLoadingPaymentDetails: false });
          // this.showModalToast(translate("api.getCarWashServiceTypeError"));
        }
      });
  }
  getBalanceAmount() {
    return new Promise((resolve, reject) => {
      let { serverUrl, accessToken } = this.state;
      var url = `${serverUrl}Services/GetBalance/`;
      fetch(url, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errors == "NoAccess" || resj.errorCode != null) {
            this.setState({ isUserValid: "No" });
          } else {
            this.setState(
              {
                userBalance: Number(resj.userBalance),
                unitBalance: Number(resj.unitBalance),
                isUserValid: "Yes",
              },
              () => {
                resolve();
              }
            );
          }
        })
        .catch((err) => {
          {
            console.log(err, "balanceAmount");
            // this.showModalToast(translate("api.getBalanceError"));
            reject(err);
          }
        });
    });
  }

  cancelOrder() {
    const cancelState = 6;
    if (this.state.orderSelected.data.numRequestStatus == 6) {
      this.showToast(translate("api.canceled"), "info");
      return;
    }
    let { serverUrl, accessToken } = this.state;
    var args = [];
    args.push(`RequestID=${this.state.orderSelected.data.numRequestID}`);
    var url = `${serverUrl}Services/PutCarwashOrderCancel/?${args.join("&")}`;
    fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((resj) => {
        if (resj.errors == "NoAccess") {
          this.showToast(translate("api.cancelNoAccess"));
        } else if (resj.errorCode != null) {
          this.showToast(translate("api.cancelNoAccess"));
        } else {
          this.showToast(translate("api.cancelSuccess"), "success");
          this.refreshOrderList();
        }
      })
      .catch((err) => {
        {
          console.log(err);
          // this.showModalToast(translate("api.cancelError"));
        }
      });
  }
  calculateRequestedItemPrice(itemId, itemPrice) {
    var requestItems = [...this.state.requestItems];

    if (this.state.requestItems.includes(itemId)) {
      const index = this.state.requestItems.indexOf(itemId);
      if (index > -1) {
        requestItems.splice(index, 1);
      }
      this.setState({
        orderPrice: this.state.orderPrice - parseInt(itemPrice),
        requestItems,
      });
    } else {
      requestItems.push(itemId);
      this.setState({
        orderPrice: this.state.orderPrice + parseInt(itemPrice),
        requestItems,
      });
    }
  }
  onDateChange(date) {
    var selectedDay = new Date(date);
    var filterDay = selectedDay;
    var dayNow = new Date();
    //number of day in week
    filterDay = (filterDay.getDay() + 1) % 7;
    if (
      this.state.carWashListServiceTime.filter(
        (timeInformation) => timeInformation.numDayOfWeek === filterDay
      ).length != 0
    ) {
      var startTime = this.state.carWashListServiceTime.filter(
        (timeInformation) => timeInformation.numDayOfWeek === filterDay
      )[0].beginTime;
      if (
        dayNow.getHours() > startTime.split(":")[0] &&
        selectedDay.getFullYear() == dayNow.getFullYear() &&
        selectedDay.getMonth() == dayNow.getMonth() &&
        selectedDay.getDay() == dayNow.getDay()
      ) {
        startTime = `${dayNow.getHours()}:${dayNow.getMinutes()}:${dayNow.getSeconds()}`;
      }
      if (
        startTime.split(":")[1] == dayNow.getMinutes() &&
        startTime.split(":")[0] == dayNow.getHours() &&
        selectedDay.getFullYear() == dayNow.getFullYear() &&
        selectedDay.getMonth() == dayNow.getMonth() &&
        selectedDay.getDay() == dayNow.getDay()
      ) {
        startTime = `${dayNow.getHours()}:${dayNow.getMinutes()}:${dayNow.getSeconds()}`;
      }

      var endTime = this.state.carWashListServiceTime.filter(
        (timeInformation) => timeInformation.numDayOfWeek === filterDay
      )[0].endTime;
      this.setState({
        startTime: startTime,
        endTime: endTime,
        pDateDesired: date,
      });
      this.hideTwoModals();
      return;
    }

    this.setState({
      filterDay: filterDay,
      pDateDesired: null,
    });
    this.showToast(translate("api.noCarWashService"));
    this.hideTwoModals();
  }
  toDigit(num) {
    if (Number(num) != NaN) {
      return (100 + Number(num)).toString().substr(1);
    }
    return num;
  }
  registerNewOrder() {
    if (
      this.state.newOrderUnitId != null &&
      this.state.requestItems.length != 0 &&
      Number.isInteger(this.state.selectedPaymentItem) &&
      this.state.pDateDesired &&
      this.state.pTimeDesiredBegin != null &&
      this.state.pTimeDesiredEnd != null
    ) {
      let { serverUrl, accessToken } = this.state;
      let args = [];
      args.push(`UnitCode=${this.state.newOrderUnitId}`);
      args.push(`RequestItems=${this.state.requestItems.toString()}`);

      args.push(`PaymentType=${this.state.selectedPaymentItem}`);
      var pDate = moment(this.state.pDateDesired)
        .format("jYYYY/jMM/jDD")
        .toString();
      var parseDate = pDate.split("/");
      pDate = parseDate[0];
      var mm = this.toDigit(parseDate[1]);
      var dd = this.toDigit(parseDate[2]);

      pDate = pDate + "/" + mm + "/" + dd;

      args.push(`PdateDesired=${pDate}`);
      args.push(`PTimeDesiredBegin=${this.state.pTimeDesiredBegin}`);
      args.push(`PTimeDesiredEnd=${this.state.pTimeDesiredEnd}`);

      if (this.state.describe) {
        args.push(`RequestDesc=${this.state.describe}`);
      } else {
        args.push(`RequestDesc=${"-"}`);
      }
      args.push(`Amount=${this.state.orderPrice}`);

      var url = `${serverUrl}Services/PostCarWashRegisterOrder/?${args.join(
        "&"
      )}`;
      fetch(url, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          if (resj.errorCode != null) {
            this.showToast(resj.errorMessage);
            this.setState({ isOrderRegistering: true });
          } else {
            if (this.state.selectedPaymentItem != 4) {
              this.hideModal();
              this.props.MyCarWashOrders(this.state.accessToken);
              this.showToast(translate("api.registeredNewOrder"), "success");
            } else if (this.state.selectedPaymentItem == 4)
              this.setState({ paymentOnlineUrl: resj.paymentUrl }, () => {
                if (Platform.OS === "web") {
                  window.open(this.state.paymentOnlineUrl);
                } else {
                  Linking.openURL(this.state.paymentOnlineUrl);
                }
              });
            if (this.props.reducer.confirm) {
              this.showToast(translate("api.registeredNewOrder"), "success");
              if (Platform.OS == "web") {
                // do something
              } else {
                this.hideModal();
                this.props.MyCarWashOrders(this.state.accessToken);
              }
            } else {
              this.showToast(
                translate("api.noPaymentOnlineSuccessFul"),
                "info"
              );
            }
          }
        })
        .catch((err) => {
          {
            console.log(err);
          }
        });
    } else {
      if (this.state.pDateDesired == null) {
        this.showToast(translate("api.enterDate"));
      } else if (this.state.newOrderUnitId == null) {
        this.showToast(translate("api.enterUnit"));
      } else if (this.state.pTimeDesiredBegin == null) {
        this.showToast(translate("api.enterTime"));
      } else if (this.state.requestItems.length == 0) {
        this.showToast(translate("api.enterItem"));
      } else if (!Number.isInteger(this.state.selectedPaymentItem)) {
        this.showToast(translate("api.enterPaymentItem"));
      }
    }
    this.setState({ isOrderRegistering: true });
  }

  render() {
    // if (this.state.isLoading) {
    //   return <Loading message={translate("app.pleaseWaite")} />;
    // } else
    if (this.state.isUserValid == "No") {
      return (
        <View
          style={{ alignItems: "center", flex: 1, justifyContent: "center" }}
        >
          <Text style={{ fontSize: 20, color: "#666666" }}>
            {translate("api.invalidUserReserveApi")}
          </Text>
        </View>
      );
    } else if (this.state.isLoading || this.props.reducer.isLoading) {
      return <Loading message={translate("app.pleaseWaite")} />;
    } else if (this.state.loadingError) {
      return (
        <View
          style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        >
          <View>
            <Text
              style={{
                color: Theme.COLORS.ERROR,
                textAlign: "center",
              }}
            >
              {translate("app.loadingError")}
            </Text>
          </View>
        </View>
      );
    }

    var orderList = [];
    var hasOrder = "";
    const short_supply = 7;
    const under_investigation = 2;
    var allOverList = this.props.reducer.carWashList;
    orderList = allOverList.filter((o) => {
      if (
        (this.state.orderStatusFilter == "ALL" ||
          o.data.numRequestStatus == this.state.orderStatusFilter ||
          (this.state.orderStatusFilter == under_investigation &&
            o.data.numRequestStatus == short_supply)) &&
        (!this.state.orderDescriptionFilter ||
          o.data.strRequestDesc.indexOf(this.state.orderDescriptionFilter) >= 0)
      )
        return o;
    });

    // orderStatuses filter
    if (allOverList && allOverList.length > 0) {
      this.orderStatuses = ["ALL"];
      for (var i in allOverList) {
        var status = allOverList[i].data.numRequestStatus;
        if (this.orderStatuses.indexOf(status) < 0 && status != short_supply) {
          this.orderStatuses.push(status);
          if (status == short_supply) {
            this.orderStatuses.push(under_investigation);
          }
        }
      }
    }
    if (this.props.reducer.carWashList.length == 0) {
      hasOrder = "No";
    }
    if (this.props.reducer.carWashList.length != 0) {
      hasOrder = "Yes";
    }
    orderList.sort((a, b) => b.id - a.id);

    var timeFilter = [];
    let times = this.state.carWashServiceTime;
    for (var i in times) {
      var timeList = [];
      startTimeParse = times[i].BeginTime.split(":");
      startTime = startTimeParse[0];
      endTimeParse = times[i].EndTime.split(":");
      endTime = endTimeParse[0];

      for (var increase = 0; increase < (endTime - startTime) * 2 + 1; i++) {
        if (increase % 2) {
          timeList.push(startTime + ":" + "00" + "-" + startTime + ":" + "30");
        } else {
          timeList.push(
            startTime + ":" + "30" + "-" + startTime + increase + ":" + "00"
          );
          startTime += 1;
        }
      }
      timeFilter.push({
        label: i.numDayOfWeek,
        value: timeList,
      });
    }

    const startDate = this.state.pDateDesired
      ? this.state.pDateDesired.toString()
      : "";

    // CreditUnitPayment
    const userBalance = 2;
    const cashPayment = 3;
    const onlinePayment = 4;
    var paymentType_Options = [
      {
        value: cashPayment,
        label: `${translate("api.cashPayment")}`,
      },
      {
        value: onlinePayment,
        label: `${translate("api.onlinePayment")}`,
      },
    ];

    if (this.state.userBalance >= this.state.orderPrice) {
      paymentType_Options.push({
        value: userBalance,
        label: `${translate("api.creditUserPayment")} (${englishToPersianNumber(
          this.state.userBalance,
          ","
        )} ${translate("api.priceUnit")}) `,
      });
    }
    if (Platform.OS == "web") {
      paymentType_Options.unshift({
        label: translate("api.paymentType"),
        value: "paymentType",
      });
    }
    // if (Platform.OS == "web") {
    //   paymentType_Options.unshift({
    //     label: translate("api.paymentType"),
    //     value: "paymentType",
    //   });
    // }

    return (
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        {this.state.isUserValid == "Yes" && (
          <View style={{ flex: 1 }}>
            {/* TouchableFilters */}
            <FilterItem
              listItem={this.orderStatuses.map((s) => {
                return { value: s, text: translate(`api.orderStatuses.${s}`) };
              })}
              selectedItem={
                this.state.orderStatusFilter || this.orderStatuses[0]
              }
              onSelect={(item) => {
                this.setState({
                  orderStatusFilter: item,
                });
              }}
            />
            {/* Filters */}
            <View
              style={[
                AppStyle.gridList_MainFiltersContainer,
                {
                  backgroundColor: Theme.COLORS.BORDER_COLOR,
                  borderBottomWidth: 1,
                  borderColor: Theme.COLORS.MUTED,
                  height: 60,
                  paddingStart: 5,
                  paddingEnd: 5,
                  justifyContent: "center",
                },
              ]}
            >
              <InputSearch
                placeholder={translate("app.searchInOrderDetails")}
                value={this.state.orderDescriptionFilter}
                onChangeText={(txt) => {
                  this.setState({ orderDescriptionFilter: txt });
                }}
              />
            </View>

            {hasOrder == "Yes" && orderList.length != 0 && (
              <ScrollView
                style={{
                  flex: 1,
                  marginBottom: 85,
                }}
              >
                {orderList.map((o) => {
                  return (
                    <OrderListItem
                      key={o.id}
                      orderData={o.data}
                      strService={o.data.numPublicServiceType}
                      toast={this.showToast}
                      onPress={() => {
                        this.setState({ showModal: 2, orderSelected: o });
                      }}
                    />
                  );
                })}
              </ScrollView>
            )}

            {hasOrder == "No" && orderList.length == 0 && (
              <View
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  flex: 1,
                }}
              >
                {!this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.disabledReservationUser")}
                  </Text>
                )}
                {this.state.reservationUser?.boolUserStatus && (
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#666666",
                    }}
                  >
                    {translate("api.noOrderRequest")}
                  </Text>
                )}
              </View>
            )}
            {this.state.reservationUser?.boolUserStatus &&
              this.state.isCarwashActive == true &&
              this.state.carWashListServiceType.length != 0 && (
                <TouchableHighlight
                  style={style.btnAdd}
                  onPress={this.pressOnAddButton}
                >
                  <FontAwesomeIcon icon={faPlus} size={30} color="#FFF" />
                </TouchableHighlight>
              )}
            {this.state.isCarwashActive == false && (
              <View
                style={{
                  height: 60,
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: -70,
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                  {translate("api.inactiveService")}
                </Text>
              </View>
            )}
            {this.state.isCarwashActive == true &&
              this.state.carWashListServiceType.length == 0 && (
                <View
                  style={{
                    height: 60,
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: -70,
                    marginBottom: 10,
                  }}
                >
                  <Text style={{ fontWeight: "bold", fontSize: 18 }}>
                    {translate("api.emptyServiceType")}
                  </Text>
                </View>
              )}
            {/* new order */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 1}
              onClose={() => this.hideModal()}
            >
              {this.state.carWashListServiceType.length != 0 && (
                <View style={[style.modalNewOrder, { flex: 1 }]}>
                  {/* 3 dropdown */}
                  <HStack
                    space="2"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: 60,
                      marginBottom: 5,
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <TouchableHighlight
                        onPress={() => {
                          this.setState({ twoModals: true });
                        }}
                        underlayColor={Theme.COLORS.BORDER}
                        style={{
                          borderColor: Theme.COLORS.BORDER,
                          borderWidth: 1,
                          borderRadius: 4,
                          backgroundColor: "#FFFFFF",
                          shadowColor: Theme.COLORS.BLACK,
                          shadowOffset: { width: 0, height: 1 },
                          shadowRadius: 2,
                          shadowOpacity: 0.05,
                          elevation: 2,
                          paddingStart: 5,
                          paddingEnd: 10,
                          marginTop: 20,
                          height: 45,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            padding: 10,
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faCalendar}
                            color="gray"
                            size={20}
                          />
                          {this.state.pDateDesired != null && (
                            <Text
                              style={{
                                paddingEnd: Platform.OS == "web" ? 0 : 6,
                                fontFamily: "IRANSansWebFaNum",
                                fontSize: 12,
                                alignItems: "flex-start",
                              }}
                            >
                              {moment(startDate).format("jYYYY/jM/jD")}
                            </Text>
                          )}
                          {this.state.pDateDesired == null && (
                            <Text style={[style.datePickerLabel]}>
                              {"  "}
                              {translate("api.serviceDay")}
                            </Text>
                          )}
                        </View>
                      </TouchableHighlight>
                      {/* calender */}
                      <ModalBase
                        avoidKeyboard={true}
                        isOpen={this.state.twoModals}
                        onClose={() => this.hideTwoModals()}
                      >
                        <View
                          style={{
                            justifyContent: "center",
                            // backgroundColor: "#fff",
                            alignItems: "center",
                            borderRadius: 5,
                            marginTop: 10,
                            padding: 10,
                            height: "100%",
                          }}
                        >
                          <PersianCalendarPicker
                            textStyle={{ fontFamily: "IRANSansWebFaNum" }}
                            minDate={new Date().toLocaleDateString("fa-IR")}
                            onDateChange={this.onDateChange}
                            selectedDayColor="blue"
                            scaleFactor={SCREEN_WIDTH * 1.2}
                          ></PersianCalendarPicker>
                        </View>
                      </ModalBase>
                    </View>
                    <View style={{ flex: 1, marginTop: 20 }}>
                      <TimePicker
                        startTime={this.state.startTime}
                        endTime={this.state.endTime}
                        interval={1800000}
                        onSelect={(start, end) => {
                          this.setState({
                            pTimeDesiredBegin: start,
                            pTimeDesiredEnd: end,
                          });
                        }}
                      />
                    </View>
                    <View style={{ flex: 1, marginTop: 20 }}>
                      <Select
                        data={this.state.areaList}
                        value={
                          Platform.OS == "web"
                            ? this.state.newOrderUnitId
                            : translate("api.orderUnit") ||
                              this.state.newOrderUnitId
                        }
                        onChangeText={(value, index, data) => {
                          this.setState({ isNewOrder: true });
                          if (Number.isInteger(value) || Number(value) > 0) {
                            this.setState({
                              newOrderUnitId: Number(value),
                            });
                          }
                        }}
                      />
                    </View>
                  </HStack>
                  {/* new items */}
                  <ScrollView
                    contentContainerStyle={{ flex: 1 }}
                    style={{
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        flexDirection: "column",
                        alignContent: "space-around",
                        marginBottom: 0,
                        minHeight: "30%",
                      }}
                    >
                      {this.state.carWashListServiceType.length != 0 && (
                        <ScrollView
                          persistentScrollbar={true}
                          contentContainerStyle={{
                            marginHorizontal: 1,
                            borderRadius: 4,
                            borderColor: Theme.COLORS.BORDER,
                          }}
                        >
                          {this.state.carWashListServiceType.length != 0 &&
                            this.state.carWashListServiceType?.map(
                              (o, i) =>
                                o.numActive != 0 && (
                                  <View
                                    key={i}
                                    onPress={() =>
                                      this.calculateRequestedItemPrice(
                                        o.numServiceTypeCode,
                                        o.numPrice
                                      )
                                    }
                                    style={{
                                      flexDirection: "row",
                                      alignItems: "center",
                                      direction: getDir(),
                                      height: 38,
                                      paddingHorizontal: 5,
                                      backgroundColor:
                                        this.state.requestItems.includes(
                                          o.numServiceTypeCode
                                        )
                                          ? "#eee"
                                          : "#fff",
                                    }}
                                  >
                                    <CheckboxBase
                                      onChange={(v) =>
                                        this.calculateRequestedItemPrice(
                                          o.numServiceTypeCode,
                                          o.numPrice
                                        )
                                      }
                                      checked={
                                        this.state.requestItems.includes(
                                          o.numServiceTypeCode
                                        )
                                          ? true
                                          : false
                                      }
                                    >
                                      <HStack space="1" mx="1">
                                        <Text>{o.strServiceTypeName} </Text>
                                        <Text>{o.numPrice} </Text>
                                        <Text>
                                          {translate("api.priceUnit")}
                                        </Text>
                                      </HStack>
                                    </CheckboxBase>
                                  </View>
                                )
                            )}
                        </ScrollView>
                      )}
                    </View>
                    <View
                      style={{
                        marginVertical: 8,
                        borderRadius: 10,
                        padding: 10,
                        width: "100%",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <Text>
                        {translate("api.servicePrice").concat(" : ")}
                        {this.state.orderPrice != 0 && (
                          <Text>
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {englishToPersianNumber(
                                this.state.orderPrice,
                                ","
                              )}{" "}
                            </Text>
                            {translate("api.priceUnit")}
                          </Text>
                        )}
                      </Text>
                    </View>
                    <View
                      style={{
                        alignItems: "stretch",
                        width: "100%",
                        // marginBottom: 10,
                        direction: getDir(),
                      }}
                    >
                      <InputBase
                        inputStyle={{ height: 40 }}
                        bg={Theme.COLORS.LIGHT_MAIN}
                        placeholder={translate("api.orderDescription")}
                        value={this.state.describe}
                        onChangeText={(text) => {
                          this.setState({ describe: text });
                        }}
                        icon={faEdit}
                      />
                    </View>
                    <View
                      style={{
                        height: 37,
                        width: "100%",
                        marginBottom: 10,
                        // flex: 1,
                      }}
                    >
                      <Select
                        label={null}
                        data={paymentType_Options}
                        value={
                          Platform.OS == "web"
                            ? this.state.selectedPaymentItem || "paymentType"
                            : translate("api.paymentType") ||
                              this.state.selectedPaymentItem
                        }
                        onChangeText={(value, index, data) => {
                          if (Number(value) > 0) {
                            this.setState({
                              selectedPaymentItem: Number(value),
                            });
                          }
                        }}
                      />
                    </View>
                    <View
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 20,
                        width: "100%",
                      }}
                    >
                      <ArButton
                        style={{ width: "100%" }}
                        onPress={() => {
                          if (this.state.isOrderRegistering) {
                            this.setState({
                              isOrderRegistering: false,
                            });
                            this.registerNewOrder();
                          }
                        }}
                      >
                        {(this.state.selectedPaymentItem != 4 &&
                          translate("api.registration")) ||
                          (this.state.selectedPaymentItem == 4 &&
                            translate("api.registration&Payment"))}
                      </ArButton>
                      {this.state.paymentOnlineUrl != null && (
                        <ArButton
                          style={{ width: "100%" }}
                          variant="outline"
                          onPress={() => {
                            Linking.openURL(this.state.paymentOnlineUrl);
                            this.hideModal();
                            this.props.MyCarWashOrders(this.state.accessToken);
                          }}
                        >
                          {translate("api.clickToPay")}
                        </ArButton>
                      )}
                    </View>
                  </ScrollView>
                </View>
              )}
              {this.state.carWashListServiceType.length == 0 && (
                <View style={style.emptyServiceType}>
                  <Text>{translate("api.emptyServiceType")}</Text>
                </View>
              )}
            </ModalBase>
            {/* details */}
            <ModalBase
              avoidKeyboard={true}
              isOpen={this.state.showModal === 2}
              onClose={() => this.hideModal()}
            >
              <View
                style={{
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  alignItems: "center",
                  borderRadius: 5,
                }}
              >
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: SCREEN_WIDTH,
                    marginTop: 7,
                  }}
                >
                  {/* icons */}
                  <View
                    style={{
                      flexDirection: "row",
                      height: 80,
                      borderColor: Theme.COLORS.BORDER,
                      borderBottomWidth: 1,
                      width: "100%",
                    }}
                  >
                    <View
                      style={{
                        flex: 1,
                        marginTop: 20,
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {this.state.orderSelected != null && (
                        <Text style={{ alignItems: "flex-end", paddingTop: 8 }}>
                          {translate("api.orderId")} :
                          <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                            {" "}
                            {englishToPersianNumber(
                              this.state.orderSelected.data.numRequestID
                            )}
                          </Text>
                        </Text>
                      )}
                      {this.state.orderSelected != null && (
                        <Text style={{ paddingTop: 10 }}>
                          {
                            this.state.orderSelected.data.strUnitName.split(
                              " "
                            )[0]
                          }{" "}
                          <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                            {
                              this.state.orderSelected.data.strUnitName.split(
                                " "
                              )[1]
                            }
                          </Text>
                        </Text>
                      )}
                    </View>
                    {this.state.orderSelected != null && (
                      <IconButton
                        style={{
                          marginBottom: 20,
                          marginEnd: 20,
                          marginStart: 20,
                          backgroundColor: "#ffffff",
                          width: 70,
                          height: 70,
                          borderRadius: 35,
                          borderWidth: 1,
                          borderColor: "#ccf",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        icon={{
                          code: getIconPicture(
                            "statusOrder",
                            this.state.orderSelected.data.numRequestStatus
                          ),
                          style: {
                            fontFamily: FONT_FAMILIES.PRO_REGULAR,
                            fontSize: 30,
                            color: "#999",
                          },
                        }}
                      />
                    )}
                  </View>
                  {/* texts */}
                  <View
                    style={{
                      flexDirection: "column",
                      height: 120,
                      // alignItems: "center",
                      alignContent: "center",
                      width: SCREEN_WIDTH * 0.8,
                      paddingBottom: 5,
                    }}
                  >
                    <View>
                      {this.state.orderSelected != null && (
                        <Text style={{ fontWeight: "bold" }}>
                          {translate("api.orderStatus")}:
                          {this.state.orderSelected.data.strRequestStatus}
                        </Text>
                      )}
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        paddingStart: 7,
                        paddingTop: 3,
                        height: 60,
                      }}
                    >
                      <View
                        style={{
                          alignItems: "flex-end",
                          flexDirection: "column",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.orderSelectedDate")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.data.dtRegPDate
                              )}
                            </Text>
                          </Text>
                        )}
                        {this.state.orderSelected != null && (
                          <Text>
                            {translate("api.dateReserve")}:
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.data
                                  .dtRibbonUserDesiredPDate
                              )}
                            </Text>
                          </Text>
                        )}
                      </View>
                      <View
                        style={{
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        {this.state.orderSelected != null && (
                          <Text style={{ marginStart: 55 }}>
                            {translate("api.orderSelectedTime")} :
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.data.dtRegTime
                              )}
                            </Text>
                          </Text>
                        )}

                        {this.state.orderSelected != null && (
                          <Text style={{ marginStart: 69 }}>
                            {translate("api.timeReserve")}:
                            <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                              {" "}
                              {englishToPersianNumber(
                                this.state.orderSelected.data
                                  .dtRibbonUserDesiredBeginTime
                              )}
                              {"-"}
                              {englishToPersianNumber(
                                this.state.orderSelected.data
                                  .dtRibbonUserDesiredEndTime
                              )}
                            </Text>
                          </Text>
                        )}
                      </View>
                      {this.state.orderSelected != null && (
                        <View style={{ alignItems: "flex-start" }}>
                          {this.state.orderSelected.payment?.numPaymentStatus ==
                            0 &&
                            this.state.orderSelected.payment?.numPaymentType ==
                              4 && (
                              <TouchableHighlight
                                underlayColor={Theme.COLORS.BORDER}
                                onPress={() => {
                                  this.getPaymentOnlineUrl();
                                }}
                                style={{
                                  borderColor: Theme.COLORS.BORDER,
                                  borderWidth: 1,
                                  backgroundColor: "#fff",
                                  borderRadius: 3,
                                  height: 37,
                                  marginBottom: 15,
                                  padding: 9,
                                  marginEnd: 30,
                                  width: 150,
                                }}
                              >
                                <Text style={{ textAlign: "center" }}>
                                  {translate("api.onlinePayment")}
                                </Text>
                              </TouchableHighlight>
                            )}
                        </View>
                      )}
                    </View>
                    {this.state.orderSelected != null && (
                      <View
                        style={{
                          height: 20,
                          paddingBottom: 10,
                          marginBottom: 10,
                        }}
                      >
                        <InputBase
                          isDisabled={true}
                          value={this.state.orderSelected.data.strRequestDesc}
                          label={translate("api.orderDescription")}
                        />
                      </View>
                    )}
                  </View>
                  {/* order's items */}
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "column",
                        paddingTop: 5,
                      }}
                    >
                      <View style={{ height: 160 }}>
                        <View
                          style={{
                            flexDirection: "column",
                            alignContent: "space-around",
                            alignItems: "center",
                            borderColor: Theme.COLORS.BORDER,
                            borderBottomWidth: 1,
                            width: SCREEN_WIDTH * 0.8,
                            margin: 10,
                            // height: 60,
                          }}
                        >
                          {this.state.orderSelected != null && (
                            <ScrollView
                              persistentScrollbar={true}
                              contentContainerStyle={{
                                marginHorizontal: 1,
                                borderRadius: 4,
                                borderColor: Theme.COLORS.BORDER,
                              }}
                            >
                              {this.state.orderSelected.data.lstItem.map(
                                (o) => {
                                  return (
                                    <View
                                      key={o.strCarWashService}
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        justifyContent: "flex-end",
                                        paddingStart: 5,
                                      }}
                                    >
                                      <Text>{o.strCarWashService} </Text>
                                      <Text
                                        style={{
                                          fontFamily: "IRANSansWebFaNum",
                                        }}
                                      >
                                        {englishToPersianNumber(
                                          o.numRequestItemPrice,
                                          ","
                                        )}{" "}
                                        {")"}
                                      </Text>
                                      <Text>
                                        {translate("api.priceUnit")}
                                        {")"}
                                      </Text>
                                    </View>
                                  );
                                }
                              )}
                            </ScrollView>
                          )}
                        </View>
                        <View style={{ alignItems: "center" }}>
                          {this.state.orderSelected != null && (
                            <Text>
                              {" "}
                              {translate("api.orderPrice")} :
                              <Text style={{ fontFamily: "IRANSansWebFaNum" }}>
                                {" "}
                                {englishToPersianNumber(
                                  this.state.orderSelected.data.numRequestPrice,
                                  ","
                                )}{" "}
                              </Text>
                              <Text>{translate("api.priceUnit")}</Text>
                            </Text>
                          )}
                        </View>
                      </View>
                    </View>
                  </View>
                  {/* end buttons */}
                  <View
                    style={{
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    {this.state.orderSelected?.data.numRequestStatus == 1 && (
                      <TouchableHighlight
                        underlayColor={Theme.COLORS.BORDER}
                        onPress={() => {
                          this.setState({ isShowingCancelAlert: true });
                        }}
                        style={{
                          borderColor: Theme.COLORS.BORDER,
                          borderWidth: 1,
                          backgroundColor: "#fff",
                          borderRadius: 3,
                          height: 37,
                          padding: 9,
                          margin: 10,
                          width: 150,
                        }}
                      >
                        <Text style={{ textAlign: "center" }}>
                          {translate("app.alertTitleCancel")}
                        </Text>
                      </TouchableHighlight>
                    )}
                    <TouchableHighlight
                      underlayColor={Theme.COLORS.BORDER}
                      onPress={() => this.hideModal()}
                      style={{
                        borderColor: Theme.COLORS.BORDER,
                        borderWidth: 1,
                        backgroundColor: "#fff",
                        borderRadius: 3,
                        height: 37,
                        padding: 9,
                        margin: 10,
                        width: 150,
                      }}
                    >
                      <Text style={{ textAlign: "center" }}>
                        {translate("api.closeOrderSelected")}
                      </Text>
                    </TouchableHighlight>
                    {this.state.isShowingCancelAlert && (
                      <AlertDialogBase
                        isOpen={true}
                        title={translate("app.alertTitleCancel")}
                        confirmText={translate("app.confirm")}
                        colorConfirm="primary"
                        confirmHandler={() => {
                          this.cancelOrder();
                          this.hideCancelConfirm();
                        }}
                        onClose={() => {
                          this.hideCancelConfirm();
                        }}
                      >
                        <Text>{translate("api.isConfirmCancel")}</Text>
                      </AlertDialogBase>
                    )}
                  </View>
                </View>
              </View>
            </ModalBase>
          </View>
        )}
      </KeyboardAvoidingView>
    );
  }
}

const style = StyleSheet.create({
  screenTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 26,
    marginBottom: 16,
    marginTop: 16,
  },
  btnAdd: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: Theme.COLORS.PRIMARY,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  datePickerLabel: {
    paddingEnd: 6,
    fontFamily: "IRANSansWebFaNum",
    fontSize: 12,
  },
  modalNewOrder: {
    width: "100%",
    padding: 5,
  },
  emptyServiceType: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.ApiReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    MyCarWashOrders: (accessToken) =>
      dispatch(Actions.MyCarWashOrders(accessToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CarWashOrdersScreen);
